export default "__VITE_ASSET__CMTGtOrw__"